import { Box, Flex, Image, Text, Progress } from "@chakra-ui/react";
import useFacialSnapshot from "core/features/intelbras/hooks/useFacialSnapshot";
import { TenantIntegracaoFacialResponse } from "core/features/tenants/typings/tenant";
import { showError } from "infra/helpers/alerta";
import { useState } from "react";
import "react-html5-camera-photo/build/css/index.css";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

interface FacialViewProps {
  faciais: TenantIntegracaoFacialResponse[];
  onClose?: () => any;
  onSubmit: (uri: string) => any;
}

function FacialView({ faciais, onClose, onSubmit }: FacialViewProps) {
  const [selectedFacialId, setSelectedFacialId] = useState<string | null>(null);

  const selectedFacial = faciais.find(
    (facial) => facial.id === selectedFacialId
  );

  const {
    data: snapshot,
    error,
    isLoading,
  } = useFacialSnapshot(selectedFacial);

  const handleSubmit = () => {
    if (snapshot) {
      onSubmit(`data:image/png;base64,${snapshot}`);
      onClose?.();
    } else {
      showError("Erro ao capturar imagem da facial");
    }
  };

  return (
    <Flex flexDir="column" h="100%" flex={1}>
      <Text mb={2}>Facial</Text>
      <Box mb={2}>
        <SelectBaseAntd
          options={faciais.map((facial) => ({
            label: facial.nome,
            value: facial.id,
          }))}
          onChange={(value) => setSelectedFacialId(value)}
        />
      </Box>

      <Box h="16px" mb={2}>
        {isLoading && (
          <Progress
            size="sm"
            isIndeterminate
            w="100%"
            my={4}
            colorScheme="cyan"
          />
        )}
      </Box>

      {error && (
        <Text textAlign="center" color="red">
          Erro ao carregar imagem da facial
        </Text>
      )}

      {selectedFacial && snapshot && !error ? (
        <Flex
          flex={1}
          justifyContent="center"
          alignItems="center"
          position="relative"
          maxH="550px"
        >
          <Image
            src={`data:image/jpeg;base64,${snapshot}`}
            w="100%"
            h="100%"
            objectFit="contain"
            alt={selectedFacial.nome}
          />

          <Flex
            position="absolute"
            left={0}
            right={0}
            bottom={0}
            bg="rgba(0, 0, 0, 0.5)"
            zIndex={1}
            marginLeft="auto"
            marginRight="auto"
            w="64px"
            h="64px"
            borderRadius="full"
            cursor="pointer"
            onClick={handleSubmit}
            alignItems="center"
            justifyContent="center"
          >
            <Box
              w="48px"
              h="48px"
              bg="rgba(255, 255, 255, 1)"
              borderRadius="full"
            />
          </Flex>
        </Flex>
      ) : null}
    </Flex>
  );
}

export default FacialView;
